import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: _ctx.getTitle,
    loading: _ctx.loading,
    onConfirm: _ctx.emitManager,
    onCancel: _ctx.emitCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_the_button, {
        class: "small primary",
        disabled: _ctx.loading,
        onClick: _ctx.emitManager,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Подтвердить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick", "loading"])
    ]),
    default: _withCtx(() => [
      (_ctx.isUpdate)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 0,
            placeholder: "Статус",
            options: _ctx.FLIGHT_DEPARTURES_STATUSES,
            value: _ctx.state.status,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.status) = $event)),
            "is-invalid": _ctx.state_form$.status.$error,
            "validation-errors": _ctx.state_form$.status.$errors
          }, null, 8, ["options", "value", "is-invalid", "validation-errors"]))
        : (_openBlock(), _createBlock(_component_file_reader, {
            key: 1,
            value: _ctx.state.files,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.files) = $event)),
            placeholder: "Выберите Excel файл (.xlsx)",
            accept: ".xlsx",
            disabled: _ctx.loading,
            "is-invalid": _ctx.state_form$.files.$error,
            "validation-errors": _ctx.state_form$.files.$errors,
            multiple: ""
          }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
    ]),
    _: 1
  }, 8, ["title", "loading", "onConfirm", "onCancel"]))
}